	jQuery(document).ready(function () {
		$ = jQuery;
		if($('#map').length>0){
			var customZoom = 4;
			if($(window).width()<700){
				customZoom = 3;
			}
			if($('body').hasClass('home')){
				customZoom = 1;
			}
			if($('body').hasClass('page-template-countries')){
				if($(window).width()<1600){
					customZoom = 3;
				}
				if($(window).width()<700){
					customZoom = 2;
				}
			}
			var mymap = L.map('map',{scrollWheelZoom:false}).setView([0, -30], customZoom);
			
			L.tileLayer('https://api.mapbox.com/styles/v1/frouault2/cjs373r7503es1fpr139ggjc9/tiles/256/{z}/{x}/{y}@2x?access_token='+params.id_mapbox, {
				maxZoom:12,
				minZoom:1,
				attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
					'<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
					'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
				
			}).addTo(mymap);
			
			//mymap.on('focus', function() { mymap.scrollWheelZoom.enable(); });
			//mymap.on('blur', function() { mymap.scrollWheelZoom.disable(); });
			
			
			var image_marker = L.icon({
							iconUrl: params.dist.dist+'img/marker.png',
							// This marker is 20 pixels wide by 32 pixels high.
							iconSize: [40, 40],
							// The anchor for this image is the base of the flagpole at (0, 32).
							iconAnchor: [20, 20],
							 popupAnchor: [0, -40]  
						  });
			var countries = $.parseJSON($('#map').attr('data-countries'));
			$.each(countries,function(index,country){
				L.marker([country.lat,country.lng], {icon: image_marker}).addTo(mymap)
					.bindPopup('<h3><a href="'+country.link+'">'+country.name+'</a></h3>');
		
			});
		}
		
		
		if($('#map_story').length>0){
			var customZoom = 4;
			if($(window).width()<700){ 
				customZoom = 3;
			}
			var countries = $.parseJSON($('#map_story').attr('countries'));
			var mymap = L.map('map_story',{scrollWheelZoom:false}).setView([countries.lat,countries.lng], customZoom);
			
			L.tileLayer('https://api.mapbox.com/styles/v1/frouault2/cjs373r7503es1fpr139ggjc9/tiles/256/{z}/{x}/{y}@2x?access_token='+params.id_mapbox, {
				maxZoom:11,
				minZoom:1,
				attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
					'<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
					'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
				
			}).addTo(mymap);
			
			//mymap.on('focus', function() { mymap.scrollWheelZoom.enable(); });
			//mymap.on('blur', function() { mymap.scrollWheelZoom.disable(); });
			
			
			var image_marker = L.icon({
							iconUrl: params.dist.dist+'img/marker.png',
							// This marker is 20 pixels wide by 32 pixels high.
							iconSize: [40, 40],
							// The anchor for this image is the base of the flagpole at (0, 32).
							iconAnchor: [20, 20],
							 popupAnchor: [0, -40]  
						  });
			
			var myCustomStyle = {
				stroke: false,
				fill: true,
				fillColor: '#ffffff',
				fillOpacity: 0.7
			}
 
			var countryPolygon = L.geoJSON($.parseJSON(countries.polygon), {
				style: myCustomStyle
			}).addTo(mymap);
			//countryPolygon.openPopup();
			
			
			var popup = L.popup({
				closeButton : false,
				closeOnClick : false,
				closeOnEscapeKey : false
			})
			.setLatLng([countries.lat,countries.lng])
			.setContent('<h3><a href="'+countries.link+'">'+countries.name+' <i class="fas fa-angle-right"></i></a></h3>')
			.openOn(mymap);
			//L.marker([countries.lat,countries.lng], {icon: image_marker}).addTo(mymap)
				//	.bindPopup('<h3><a href="'+countries.link+'">'+countries.name+'</a></h3>');
		
		}
		
	});